import React from 'react';

export function ExperienceAudio(props) {
	const { reference, experienceAudioTagUrl } = props;
	const isPageAllowed =
		reference !== 'AuthResult' &&
		reference !== 'LegalTerms' &&
		reference !== 'PromotionalVideo';

	const canPlay =
		experienceAudioTagUrl &&
		isPageAllowed &&
		(Boolean(navigator?.userActivation)
			? navigator?.userActivation.isActive
			: true);

	return (
		<>{canPlay && <audio src={experienceAudioTagUrl} autoPlay loop></audio>}</>
	);
}
